/**
 * @module navigation/primaryMenuItem
 * @requires module: navigation/commonMenuItem
 * @requires module: navigation/menuStateManager
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

'use strict';

/**
 * @type {CommonMenuItem}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _commonMenuItem = require('./commonMenuItem');

var _commonMenuItem2 = _interopRequireDefault(_commonMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Primary Menu Item
 * @augments CommonMenuItem
 * @constructor
 */
function PrimaryMenuItem() {
  _commonMenuItem2.default.prototype.constructor.apply(this, arguments);
}
PrimaryMenuItem.prototype = (0, _create2.default)(_commonMenuItem2.default.prototype);

/**
 * Get width of inner item element
 * @protected
 * @returns {number}
 */
PrimaryMenuItem.prototype.getItemWidth = function () {
  return this.$obj.get(0).offsetWidth;
};

exports.default = PrimaryMenuItem;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/primaryMenuItem.js
// module id = 1781
// module chunks = 1